import { Paper, Typography } from '@occc-app/design-system';
import PopupState, { bindHover, bindPopover } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';

export type TriggeredRulesInfoProps = {
  rules: { ruleId: string; description: string }[];
};

export const TriggeredRulesInfo = ({ rules }: TriggeredRulesInfoProps) => (
  <PopupState variant='popover' popupId='triggered-rules'>
    {(popupState) => (
      <div>
        <Typography variant='subtitle1' {...bindHover(popupState)}>
          {rules.length} Issues Identified
        </Typography>
        <HoverPopover
          {...bindPopover(popupState)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Paper sx={{ p: 1 }}>
            <Typography fontWeight='bold' mb={1}>
              Rule(s) Triggered:
            </Typography>
            {rules.map((rule) => (
              <Typography key={rule.ruleId} variant='body2' mb={0.5}>
                <strong>{rule.ruleId}</strong>: {rule.description}
              </Typography>
            ))}
          </Paper>
        </HoverPopover>
      </div>
    )}
  </PopupState>
);
